import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { HYDRATE } from "@/redux/reducers/hydration";

export enum ToastType {
  Info,
  Warning,
  Error,
}

export type Toast = {
  id: string;
  message: React.ReactNode;
  type: ToastType;
};

export type ToastsState = {
  toasts: Toast[];
};

export const initialState: ToastsState = {
  toasts: [],
};

const toastsSlice = createSlice({
  extraReducers: (builder) => {
    /**
     * Ignore any hydration events after initial page load to preserve any
     * subsequent changes that have been made on the client.
     */
    builder.addCase(HYDRATE, () => {});
  },
  initialState,
  name: "toasts",
  reducers: {
    dismiss(state, action: PayloadAction<string>) {
      state.toasts = state.toasts.filter(
        (toast) => toast.id !== action.payload,
      );
    },
    notify(state, action: PayloadAction<Toast>) {
      state.toasts.push(action.payload);
    },
  },
});

export const { notify, dismiss } = toastsSlice.actions;
export default toastsSlice.reducer;
